@if (!hasResult) {
  <app-advisor-errorpage></app-advisor-errorpage>
}

@if (hasResult) {
  <div class="grid-x grid-margin-x headline-wrapper ng-star-inserted">
    <div class="cell small-12 large-12">
      @if(forceDialog || showDownload) {
        <dialog-hint [clickTarget]="idTargetElement"
          [textkey]="'heizcheck.verbrauchsanalyse.ergebnis.callout' | translate"
        remeberCloseId="moc-result-hint" [closable]="true"></dialog-hint>
      }
    </div>
    <div class="cell text-center">
      @if (hasResult) {
        <h1 [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.headline.' + simpleStage | translate: placeholder"></h1>
      }
      @if (!hasResult) {
        <h1 [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.nodata' | translate"></h1>
      }
    </div>
  </div>
}

@if (hasResult) {
  <div>
    <section class="grid-x grid-margin-x">
      <div class="cell small-12 medium-10 medium-offset-1">
        <app-building-condition (stageSet)="setStage($event)" textKeyPrefix="heizcheck.verbrauchsanalyse.ergebnis.condition" [textPlaceholder]="placeholder" [hintTextPostfix]="isApartement? '.apartement' : '.building'" [isApartementBuilding]="apartementBuilding" [markFloorInApartement]="markApartement" [value]="result['evkw']" [min]="result['evkw_minimum']" [max]="result['evkw_maximum']" [avg]="result['evkw_durchschnitt']"></app-building-condition>
      </div>
    </section>
    <section class="arrow-down-wrapper">
      <h2 class="text-center" [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.description' | translate: placeholder"></h2>
      <div class="grid-x grid-margin-x">
        <div class="cell small-12 large-offset-2 medium-offset-1 medium-5 large-4">
          <h3 [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.energy.headline' | translate: placeholder"></h3>
          <p [innerHTML]="('heizcheck.verbrauchsanalyse.ergebnis.energy.text.' + simpleStage) | translate: placeholder"></p>
        </div>
        <div class="cell small-12 medium-5 large-4 end">
          <h3 [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.co2.headline' | translate: placeholder"></h3>
          <p  [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.co2.text' | translate: placeholder"></p>
        </div>
      </div>
      <span class="copyright" [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.copyright' | translate"></span>
    </section>
    @if (compareData) {
      <section class="costs-compare-wrapper hec">
        <app-forecast-chart
          [anfrage]="anfrage"
          [placeholder]="placeholder"
          [dataCases]="dataCases"
          [compareData]="compareData"
          [forecastData]="forecastData"
          (typeChanged)="setForecastType($event)"
          [hints]="hints"
          (hintToggled)="toggleHint($event)"
          mode="hec"
          textkeyPrefix="heizcheck.verbrauchsanalyse.ergebnis.heizkostenvergleich">
        </app-forecast-chart>
      </section>
    }
    @if (stages.teaser && !familyHouseDezentral2) {
      <app-advisor-teaser [url]="mocUrls?.secondChapter? mocUrls.secondChapter : null" [mailUrl]="mocUrls?.plain? mocUrls.plain : null"
        textPrefix="heizcheck.verbrauchsanalyse.ergebnis.teaser" [textPostfix]="'.' + stages.teaser" [headlinePostfix]="'.' + stages.headline" [showImage]="!internalPortal"
      [placeholder]="placeholder" image="/hec/moc-teaser.svg"></app-advisor-teaser>
    }
    @if(forceDialog || showDownload) {
      <section class="hint-wrapper">
        <div class="grid-x">
          <div class="cell medium-10 medium-offset-1 large-offset-2 large-8">
            <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 55.867 120.602">
            <path d="M51.138,95.189c0,0.507-0.193,0.953-0.58,1.34l-21.435,21.435c-0.09,0.089-0.187,0.149-0.291,0.179
              c-0.104,0.03-0.201,0.089-0.29,0.179c-0.09,0.089-0.217,0.142-0.38,0.156c-0.164,0.015-0.29,0.022-0.38,0.022
              c-0.089,0-0.216-0.007-0.379-0.022c-0.164-0.015-0.291-0.067-0.38-0.156c-0.09,0-0.187-0.037-0.29-0.112
              c-0.105-0.074-0.201-0.156-0.291-0.246L5.008,96.529c-0.388-0.387-0.581-0.833-0.581-1.34c0-0.506,0.193-0.953,0.581-1.34
              c0.387-0.387,0.833-0.581,1.34-0.581c0.506,0,0.953,0.194,1.34,0.581l18.175,18.174V6.116c0-0.565,0.179-1.027,0.535-1.385
              c0.357-0.357,0.819-0.536,1.385-0.536s1.027,0.179,1.385,0.536s0.536,0.819,0.536,1.385v105.907l18.174-18.174
              c0.387-0.387,0.834-0.581,1.341-0.581c0.506,0,0.952,0.194,1.34,0.581C50.945,94.236,51.138,94.683,51.138,95.189z"/>
            </svg>
            <h2 [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.hint.headline' | translate"></h2>
            <p
            [innerHTML]="'heizcheck.verbrauchsanalyse.ergebnis.hint.text' + (selfUser? '.user' : '.nouser') | translate"></p>
          </div>
        </div>
      </section>
    }
    @if (forceDialog) {
      <section [id]="idTargetElement" class="dialogform-wrapper">
        <app-dialogform textkeyPrefix="heizcheck" copyright=".dialogform.copyright" advisorImagePath="/hec/hec-lead.svg" [registrationData]="dialogData" (onDialogRegister)="dialogRegistered($event)" downloadUrl="reportUrl"></app-dialogform>
      </section>
    }
    @if (!mocUrls && tipps) {
      <section class="tipps-wrapper">
        <h2 class="text-center" [innerHTML]="'heizcheck.ergebnis.tipps.headline' | translate"></h2>
        <app-tipps-slider [tipps]="tipps" textPrefix="heizcheck.tipps"></app-tipps-slider>
      </section>
    }
    @if (showDownload) {
      <section  [id]="idTargetElement" class="download-wrapper">
        <app-download [url]="reportUrl" textkeyPrefix="heizcheck.ergebnis."></app-download>
      </section>
    }
    <app-portal-teaser></app-portal-teaser>
    <!--  <app-donate *ngIf="internalPortal === true" textkeyPrefix="heizcheck"></app-donate>-->
  </div>
}
@if (hasResult) {
  <app-step-buttons  [previousLink]="lastStep" leftAlignSize="small" previousText="step.button.previous" [nextLink]="null" [nextSubmit]="false"></app-step-buttons>
}

